module.exports = __webpack_public_path__ + "static/media/soccorso_stradale_axa.916547a0.svg";